
const digest = '1497797f8a1e688293e3e191d113ca8eca38880060383dfe91d9ca492c97b865';
const css = `._toolbar_12w0r_1 {
  border-radius: var(--aha-editor-v2--border-radius)
    var(--aha-editor-v2--border-radius) 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 30px;
  background-color: var(--theme-editor-toolbar);
  position: relative;
  padding: 3px;
}

._elementToolbarButton_12w0r_13 svg {
  pointer-events: none;
}

/* Don't change toolbar in fullscreen. Seems unnecessary now toolbar is bigger.
.toolbar.fullScreen {
  visibility: visible !important;
  margin: 0 !important;
  border-radius: 0 !important;
  border-bottom: 1px solid var(--aha-blue-200);

  .toolbarButton {
    font-size: 15px !important;
    i {
      font-size: 15px !important;
    }
    line-height: 1.5;
  }
}
*/

._toolbarItems_12w0r_34 {
  display: flex;
  align-items: center;
  gap: 1px;
  opacity: 1;
  transition: opacity 0.2s;
}

._faded_12w0r_42 {
  opacity: 0;
  transition: opacity 0s;
}

._toolbarSection_12w0r_47 {
  display: flex;
  flex-direction: row;
}

._toolbarButton_12w0r_24,
._toolbarItem_12w0r_34 {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--editor-v2-toolbar-button-color);
  border-radius: var(--editor-v2-toolbar-button-radius);
  font-size: var(--editor-v2-toolbar-button-font-size);
  height: var(--editor-v2-toolbar-button-size);
  min-width: var(--editor-v2-toolbar-button-size);
  font-weight: 400;
  line-height: var(--editor-v2-toolbar-button-font-size);
  padding: 2px 5px;
  margin: 1px;
}

._hideCaret_12w0r_69::after {
  display: none;
}

._toolHDivider_12w0r_73 {
  border-right: 1px solid var(--theme-secondary-border);
  margin: 4px 5px;
}

._toolbarButton_12w0r_24 .fa-caret-down {
  margin-left: 0.3rem;
}

._toolbarButton_12w0r_24:hover,
._toolbarItem_12w0r_34:hover {
  background-color: var(--theme-editor-button-hovered);
  color: var(--aha-gray-900);
}

._toolbarButton_12w0r_24:active,
._toolbarItem_12w0r_34:active,
aha-menu[open] > ._toolbarButton_12w0r_24,
aha-menu[open] > ._toolbarItem_12w0r_34 {
  color: var(--aha-blue-700);
  background-color: var(--aha-blue-300);
}

._toolbarButton_12w0r_24[aria-disabled='true'],
._toolbarItem_12w0r_34[aria-disabled='true'] {
  opacity: 0.3;
  pointer-events: none;
}

._toolbarButton_12w0r_24[aria-selected='true'],
._toolbarItem_12w0r_34[aria-selected='true'] {
  color: var(--aha-blue-700);
  background-color: var(--theme-editor-button-active);
}

._toolbarButtonText_12w0r_108 {
  font-size: 12px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}

/* We need to override all styles so we override the bootstrap form.less styles
 * that are applied to all inputs. */
._toolbarInput_12w0r_118 {
  width: 200px;
  border: none;
  padding: 3px !important;
  margin: 0 !important;
  border-radius: var(--Common--border-radius) !important;
  box-shadow: none !important;
}
._toolbarInput_12w0r_118:focus {
  outline: 2px solid var(--aha-blue-400) !important;
  box-shadow: none !important;
}

._hintToolShortcut_12w0r_131 {
  padding: 2px 4px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.2);
}

._cellBackgroundColorIcon_12w0r_137 {
  width: 14px;
  height: 14px;
  border: 1px solid var(--theme-secondary-border);
  border-radius: 50%;
}

._tableBorderColorIcon_12w0r_144 {
  display: block;
  width: 12px;
  height: 12px;
  border: 3px solid var(--theme-secondary-border);
  border-radius: 50%;
}

._colorIconNone_12w0r_152 {
  background: linear-gradient(
    to top right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) calc(50% - 2px),
    rgb(214, 157, 157) 50%,
    rgba(0, 0, 0, 0) calc(50% + 2px),
    rgba(0, 0, 0, 0) 100%
  );
}

._toolbar_12w0r_1 aha-tooltip {
  --Tooltip__tooltip--font-size: 14px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"toolbar":"_toolbar_12w0r_1","elementToolbarButton":"_elementToolbarButton_12w0r_13","toolbarItems":"_toolbarItems_12w0r_34","faded":"_faded_12w0r_42","toolbarSection":"_toolbarSection_12w0r_47","toolbarButton":"_toolbarButton_12w0r_24","toolbarItem":"_toolbarItem_12w0r_34","hideCaret":"_hideCaret_12w0r_69","toolHDivider":"_toolHDivider_12w0r_73","toolbarButtonText":"_toolbarButtonText_12w0r_108","toolbarInput":"_toolbarInput_12w0r_118","hintToolShortcut":"_hintToolShortcut_12w0r_131","cellBackgroundColorIcon":"_cellBackgroundColorIcon_12w0r_137","tableBorderColorIcon":"_tableBorderColorIcon_12w0r_144","colorIconNone":"_colorIconNone_12w0r_152"};
export { css, digest };
  